import React from 'react';
import { Link } from 'react-router-dom';
import { ProjectsNeedAttentionTable } from '../tables/BuildingNeedAttentionTable';
import { useListProjectsBuildingView } from 'api/projects/projectsServices';
import { useConditionalRender } from 'hooks/useConditionalRender';

interface ProjectsNeedAttentionSectionProps {
  buildingId: string | undefined;
  severity: string;
}

const ProjectsNeedAttentionSection: React.FC<
  ProjectsNeedAttentionSectionProps
> = ({ buildingId, severity }) => {
  const { data, isFetching } = useListProjectsBuildingView(buildingId);
  const { shouldRender } = useConditionalRender({
    isFetching,
    data: data?.needs_attention,
  });

  if (!shouldRender) {
    return null;
  }

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex justify-between items-center my-2">
        <h3 className="font-bold uppercase">Most important projects</h3>
        <Link
          to={`/app/management/projects?asset=${buildingId ?? ''}`}
          className="text-base mr-6 text-tertiary-dark"
        >
          See all
        </Link>
      </div>
      <ProjectsNeedAttentionTable buildingId={buildingId} severity={severity} />
    </div>
  );
};

export default ProjectsNeedAttentionSection;
